import { Box, Card, Grid, Typography, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import CustomButton from "../../components/customButton";
import { CircleUser, ClipboardCheck } from "lucide-react";
import CampaignIcon from "@mui/icons-material/Campaign";
import DashboardCard from "../../components/card/dashboardCard";
import TaskCompletionChart from "../../components/charts/redical";
import AttendanceHeatmapChart from "../../components/charts/heatCharts";
import TaskColumnChart from "../../components/charts/taskColumnChart";
import { getDashboardData } from "../../services/Auth";
import AppLoader from "../../components/appLoader";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await getDashboardData();
      if (response.status === 200 || response.status === 201) {
        setDashboardData(response.data.data);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError("Error fetching dashboard data");
      console.error("Dashboard data fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  //   if (!dashboardData) {
  //     return <Typography>No data available</Typography>;
  //   }

  const { overview, charts } = dashboardData || {};

  const cardData = [
    {
      title: "Total Employees",
      value: overview?.totalEmployees?.toString() || "0",
      subtext: "Total registered employees",
      subtextColor: "#2e7d32",
    },
    {
      title: "Active Today",
      value: overview?.activeToday?.toString() || "0",
      subtext: "Currently working",
      subtextColor: overview?.activeToday > 0 ? "#2e7d32" : "#9e9e9e",
    },
    {
      title: "Late Check-Ins",
      value: overview?.lateCheckIns?.toString() || "0",
      subtext: "Arrived late today",
      subtextColor: overview?.lateCheckIns > 0 ? "error.main" : "#2e7d32",
    },
    {
      title: "On Break Now",
      value: overview?.onBreakNow?.toString() || "0",
      subtext: "Currently on break",
      subtextColor: overview?.onBreakNow > 0 ? "#ff9800" : "#2e7d32",
    },
    {
      title: "Tasks Assigned Today",
      value: overview?.tasksAssignedToday?.toString() || "0",
      subtext: "New tasks today",
      subtextColor: "#2e7d32",
    },
    {
      title: "Tasks Completed Today",
      value: overview?.tasksCompleted?.toString() || "0",
      subtext: "Completed today",
      subtextColor: "#2e7d32",
    },
    // {
    //   title: "Recent Logins",
    //   value: overview?.recentLogins?.toString() || "0",
    //   subtext: "Logged in recently",
    //   subtextColor: "#2e7d32",
    // },
    // {
    //   title: "Workers Who Didn't Login",
    //   value: overview?.workersWhoDidntLogin?.toString() || "0",
    //   subtext: "Haven't logged in today",
    //   subtextColor:
    //     overview?.workersWhoDidntLogin > 0 ? "error.main" : "#2e7d32",
    // },
  ];
  return (
    <>
      <Box
        bgcolor="primary.bgLight"
        padding={"20px"}
        borderRadius={"22px"}
        mt={0}
      >
        <AppLoader isVisible={loading} />
        <Grid container spacing={2}>
          <Grid item sm={12} md={5}>
            <Typography variant="h4">Dashboard</Typography>
            <Typography variant="description">
              Quick insight and control center for workplace operations
            </Typography>
          </Grid>
          <Grid item sm={12} spacing={2} md={7}>
            {/* <Box display={"flex"} justifyContent={"flex-end"} gap={1.5}>
                            <CustomButton
                                btnLabel={"Add new employee"}
                                variant={"webbutton"}
                                btnTextSize={10}
                                startIcon={<CircleUser color="#ffffff" size={14} strokeWidth={2} />}
                            />
                            <CustomButton
                                btnLabel={"Assign task"}
                                variant={"outlinebutton"}
                                btnTextSize={10}
                                btnTextColor={"#225B27"}
                                startIcon={<ClipboardCheck color="#225B27" size={16}  strokeWidth={1.75} />}
                            />
                            <CustomButton
                                btnLabel={"Broadcast announcement"}
                                variant={"outlinebutton"}
                                btnTextSize={10}
                                btnTextColor={"#225B27"}
                                startIcon={<CampaignIcon color="#225B27" size={16} />}
                            />
                        </Box> */}
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          {cardData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <DashboardCard {...card} />
            </Grid>
          ))}
        </Grid>

        <Card
          sx={{
            background: "#fff",
            borderRadius: 4,
            minHeight: 130,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            p: 2,
            boxShadow: "6px 6px 15px rgba(0, 0, 0, 0.2)",
            mt: 2,
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={7}>
              <TaskColumnChart data={charts?.taskAnalyticsByMonth} />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <TaskCompletionChart data={charts?.taskCompletion} />
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  );
};

export default Dashboard;
